<template>
    <div class="pane-template sticky-header" v-if="tools.currentPaneKey === 'user'">
        <pane-header
            :title="user.title"
            :subtitle="user.sub"
            :tools="tools"
            v-if="!hideHeader"
            :appIconKey="user.type"
            :hasCloseIcon="true"
        />
        <pane-content-with-sidebar :updateWhenThisValueChanges="expandAll">
            <pane-section id="user-information" title="User information" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed(false)">
                <ui-link slot="pane-header-right" @click="toggleExpandAll">{{ expandAll === false ? 'Collapse all' : 'Expand all' }}</ui-link>
                <ui-details size="p25" class="no-padding" :list="[
                    {
                        label: 'Patron group',
                        value: user.patron_group,
                    },
                    {
                        label: 'Status',
                        value: user.status,
                    },
                    {
                        label: 'Expiration date',
                        value: user.expiration_date,
                    },
                    {
                        label: 'Username',
                        value: user.username,
                    },
                ]"></ui-details>
                <pane-section title="Extended Information" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                </pane-section>
                <pane-section title="Contact information" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                    <skeleton-lines :lines="4"></skeleton-lines>
                </pane-section>
                <pane-section title="Addresses" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                    <skeleton-lines :lines="3"></skeleton-lines>
                </pane-section>
            </pane-section>
            <pane-section id="proxy" title="Proxy" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                <skeleton-lines :lines="20"></skeleton-lines>
            </pane-section>
            <pane-section id="fees-and-fines" title="Fees and fines" :itemCountMax="4" :itemCountMin="2" preset="fee" :includeInList="{ user }" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                <ui-button slot="pane-header-right" @click="viewUserFees">View history</ui-button>
            </pane-section>
            <pane-section
                id="loans"
                :hasButton="false"
                title="Loans"
                :tools="tools"
                :isCollapsed="isCollapsed(false)"
                :includeInList="{ user }"
            >
                <ui-button @click="viewUserLoans" slot="pane-header-right">View Loans</ui-button>
                <ui-link @click="viewUserLoans">Open loans</ui-link><br />
                <ui-link @click="viewUserLoans">Closed loans</ui-link>
            </pane-section>
            <pane-section id="communications" title="Communications" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                <skeleton-lines :lines="20"></skeleton-lines>
            </pane-section>
            <pane-section id="patron-groups" title="Patron groups" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                <skeleton-lines :lines="20"></skeleton-lines>
            </pane-section>
            <pane-section id="staff-permissions" title="Staff permissions" :tools="tools" :hasButton="false" :isCollapsed="isCollapsed()">
                <ui-button slot="pane-header-right">Add permission</ui-button>
                <skeleton-lines :lines="20"></skeleton-lines>
            </pane-section>
        </pane-content-with-sidebar>
    </div>
</template>

<script>
    export default {
        name: 'pane-user-template',
        props: ['tools', 'hideHeader'],
        data() {
            return {
                expandAll: null,
            };
        },
        computed: {
            user() {
                return this.currentView.data.pane;
            },
            currentView() {
                return this.tools.currentView;
            },
        },
        methods: {
            toggleExpandAll() {
                this.expandAll = typeof this.expandAll !== 'boolean' ? false : !this.expandAll;
            },
            isCollapsed(defaultState) {
                if (typeof this.expandAll === 'boolean') {
                    return this.expandAll;
                }

                return typeof defaultState !== 'undefined' ? defaultState : true;
            },
            changeViewRelativeToUser(data) {
                const { user, currentView } = this;

                this.tools.changeView({
                    ...currentView,
                    key: 'users-view',
                    title: user.name,
                }, null, true);

                this.tools.changeView(data);
            },
            viewUserLoans() {
                const { user } = this;

                this.changeViewRelativeToUser({
                    key: 'loans-view',
                    title: 'Loan History',
                    owner: 'users',
                    data: {
                        user,
                    },
                });
            },
            viewUserFees() {
                const { user } = this;

                this.changeViewRelativeToUser({
                    key: 'fees-view',
                    title: 'Fee/fine history',
                    owner: 'users',
                    data: {
                        user,
                    },
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// UserPaneTemplate.vue?57221752